import { useMemo } from "react"

import { useSearchParams } from "react-router-dom"
import { IDashboardBehaviorSelection } from "ts/interfaces/AdminDashboard"

import { parseBehaviorSelection } from "./behaviorFormat"

const TYPE_KEY = "ov_behavior_type"
const TITLE_KEY = "ov_behavior_title"

// The Overview's selected behaviour, kept in the URL next to its period.
const useBehaviorSelection = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const rawType = searchParams.get(TYPE_KEY)
  const rawTitle = searchParams.get(TITLE_KEY)
  // Stable per URL value, so it can key queries and be compared by reference.
  const selection = useMemo(
    () => parseBehaviorSelection(rawType, rawTitle),
    [rawType, rawTitle],
  )

  // Merges into the current params and replaces the history entry, like the
  // period filter.
  const write = (type: string | null, title: string | null) => {
    const next = new URLSearchParams(searchParams)
    if (type === null || title === null) {
      next.delete(TYPE_KEY)
      next.delete(TITLE_KEY)
    } else {
      next.set(TYPE_KEY, type)
      next.set(TITLE_KEY, title)
    }
    setSearchParams(next, { replace: true })
  }

  const select = ({ type, title }: IDashboardBehaviorSelection) =>
    write(type, title)
  const clear = () => write(null, null)

  return { selection, select, clear }
}

export default useBehaviorSelection
